import { fetchClient } from "../lib/openapi-query";

export interface ActivityRecommendation {
  id: number;
  activityName: string;
  locale: string;
  sku: string;
  priority: number;
  createdAt: string;
  updatedAt: string;
}

export interface ActivityWithProducts {
  activityName: string;
  products: any[];
  recommendations: ActivityRecommendation[];
}

export interface AddRecommendationRequest {
  activityName: string;
  sku: string;
  priority?: number;
  locale: string;
}

export interface RemoveRecommendationRequest {
  activityName: string;
  sku: string;
  locale: string;
}

export interface UpdatePriorityRequest {
  activityName: string;
  sku: string;
  newPriority: number;
  locale: string;
}

export const activityRecommendationsApi = {
  getAll: async ({
    locale,
  }: {
    locale: string;
  }): Promise<ActivityWithProducts[]> => {
    const response = await fetchClient.GET(
      "/products/activity-recommendations" as any,
      {
        params: {
          query: { locale } as any,
        },
      }
    );

    if (response.error) {
      throw new Error("Failed to fetch activity recommendations");
    }

    return response.data as unknown as ActivityWithProducts[];
  },

  add: async (
    data: AddRecommendationRequest
  ): Promise<{ success: boolean }> => {
    const response = await fetchClient.POST(
      "/products/activity-recommendations" as any,
      {
        body: data as any,
      }
    );

    if (response.error) {
      throw new Error("Failed to add activity recommendation");
    }

    return response.data as unknown as { success: boolean };
  },

  remove: async (
    data: RemoveRecommendationRequest
  ): Promise<{ success: boolean }> => {
    const response = await fetchClient.DELETE(
      "/products/activity-recommendations" as any,
      {
        body: data as any,
      }
    );

    if (response.error) {
      throw new Error("Failed to remove activity recommendation");
    }

    return response.data as unknown as { success: boolean };
  },

  updatePriority: async (
    data: UpdatePriorityRequest
  ): Promise<{ success: boolean }> => {
    const response = await fetchClient.PATCH(
      "/products/activity-recommendations/priority" as any,
      {
        body: data as any,
      }
    );

    if (response.error) {
      throw new Error("Failed to update recommendation priority");
    }

    return response.data as unknown as { success: boolean };
  },
};
